<template>
    <div class="archive-form should-dim modify-form m-t-sm">
        <div>
            Are you sure you want to void the next invoice?
        </div>
        <div class="flex flex-col gap-sm m-t-sm">
            <ladda-button @lbClicked="voidInvoice" el-class="btn-danger" :loading="loading">
                Yes, void invoice
            </ladda-button>
            <button v-on:click="hideDeleteForm" class="btn btn-default">Cancel</button>
            <small v-show="error"><span class="text-danger">{{ errorMessage }}</span></small>
        </div>
    </div>
</template>

<script>
import LaddaButton from '../../shared/ladda_button.vue';

export default {
  name: 'void-invoice-form',
  components: { LaddaButton },
  props: [
    'invoice',
  ],
  data() {
    return {
      loading: false, // Loading is a network variable (hitting the api)

      error: false,
      errorMessage: 'Error, please try again later or contact support.',
    };
  },
  methods: {
    hideDeleteForm() {
      const vm = this;
      vm.$notificationManager.emit('hide-void-form', vm.invoice);
    },
    voidInvoice: _.throttle(function () {
      const vm = this;
      // If this is a duplicate request, just return
      if (vm.loading === true) {
        return;
      }
      vm.loading = true;

      const url = vm.$apiService.manualInvoiceUrl(vm.invoice.id);
      axios.delete(url)
        .then((response) => {
          vm.loading = false;
          vm.$notificationManager.emit('show-toast', 'Invoice voided', true);
          vm.$notificationManager.emit('invoice-voided', vm.invoice);
        })
        .catch((error) => {
          vm.loading = false;
          vm.errorMessage = 'Error, please try again later or contact support.';
          vm.error = true;
        });
    }, 500),
  },
};
</script>
